import { GoldIcon } from "@components/components";
import React from "react";
import * as S from "./card-component.style";
import { CardProps } from "./card-component.types";

const Card: React.FC<CardProps> = ({ subtitle, title, icon, children }) => {
	return (
		<S.CardContainer>
			<S.CardInnerContainer>
				<S.CardHeaderContainer>
					{icon && <GoldIcon icon={icon} />}
					<S.CardTitle>{title}</S.CardTitle>
				</S.CardHeaderContainer>
				<S.CardSubtitle>{subtitle}</S.CardSubtitle>
				{children}
			</S.CardInnerContainer>
		</S.CardContainer>
	);
};

export default Card;
